import { Condition } from "@/services/backend/deliveries/state/state";
import { cn } from "@/shared/lib/utils";

export const deliveryConditionLabel: { [key: string]: string } = {
  [Condition.Fine]: "In Ordnung",
  [Condition.SlightlyDamaged]: "Leicht beschädigt",
  [Condition.HeavilyDamaged]: "Schwer beschädigt",
  [Condition.Rejected]: "Zurückgewiesen",
};

export function DeliveryConditionLabel({ status }: { status: string }) {
  return <span className={cn("flex")}> {deliveryConditionLabel[status]} </span>;
}
